// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-divider {
  display: inline-block;
  vertical-align: top;
  border-left: 1px solid rgb(234.6, 234.6, 234.6);
  margin-left: 8px;
  margin-right: 8px;
  height: 21px;
}

/* .individual-view {
	height: calc(100vh - 50px - 0 - 80px);
	//margin-right: -17px;
}
 */
.units-collapse {
  display: flex;
  padding: 5px 2px 0px 2px;
  background-color: #f1f6f9;
}

.units-menu {
  min-width: 27%;
  margin: 2px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.units-menu-itemName {
  font-size: 11px;
  font-weight: bold;
  margin-left: 2px;
  cursor: pointer;
}

a.list-row, a.list-row * {
  text-decoration: none;
  cursor: pointer;
  align-items: center;
}

.list-row.sticky {
  margin: 0;
}

.list-view, .list-view-group {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
}
.list-view.with-padding-right .list-row, .with-padding-right.list-view-group .list-row {
  padding-right: 10px;
}
.list-view .list-row, .list-view-group .list-row {
  display: block;
  padding: 5px;
}
.list-view .list-row .pull-right, .list-view-group .list-row .pull-right {
  text-align: right;
}
.list-view .disabled-icons:not(.disabled-row) .action-item, .list-view-group .disabled-icons:not(.disabled-row) .action-item {
  opacity: 0.5;
}
.list-view .list-footer-row, .list-view-group .list-footer-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  display: flex;
  padding: 6px 10px;
  border-radius: 0 0 6px 6px;
}
.list-view .trip-date-row, .list-view-group .trip-date-row {
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 5px;
  display: flex;
  font-weight: 600;
  font-style: italic;
  line-height: 26px;
  align-items: center;
  border-radius: 6px 6px 0 0;
}
.list-view .trip-date-row .material-icons, .list-view-group .trip-date-row .material-icons {
  vertical-align: middle;
}
.list-view .trip-date-row .pull-right, .list-view-group .trip-date-row .pull-right {
  margin-left: auto;
}
.list-view a, .list-view-group a {
  color: inherit;
}
.list-view .not-updated .action-running, .list-view-group .not-updated .action-running {
  opacity: 0.25;
}
.list-view .action-item, .list-view-group .action-item {
  float: left;
}
.tracks-view .list-view .action-item, .tracks-view .list-view-group .action-item {
  display: flex;
  align-items: center;
}
.list-view .action-item a, .list-view-group .action-item a {
  display: block;
}
.list-view .action-item .material-icons, .list-view-group .action-item .material-icons, .list-view .action-item i, .list-view-group .action-item i {
  color: inherit;
  vertical-align: middle;
}
.list-view .action-item.unknownunknown, .list-view-group .action-item.unknownunknown, .list-view .action-item.unknownonline, .list-view-group .action-item.unknownonline {
  opacity: 0.25;
}
.list-view .action-item.online, .list-view-group .action-item.online {
  color: #28a745;
}
.list-view .action-item.unknownunknown, .list-view-group .action-item.unknownunknown, .list-view .action-item.unknown, .list-view-group .action-item.unknown {
  color: #ffc107;
}
.list-view .action-item.stop, .list-view-group .action-item.stop {
  color: #dc3545;
}
.list-view .action-item.offline, .list-view-group .action-item.offline {
  color: #d7d7d7;
}
.list-view .action-item.away, .list-view-group .action-item.away {
  color: #ffc107;
}
.list-view .action-item .sub-menu, .list-view-group .action-item .sub-menu {
  min-width: 200px;
}
.list-view .action-item.action-connection.offline, .list-view-group .action-item.action-connection.offline {
  color: #dc3545;
}
.list-view .action-item.action-connection.not-exists, .list-view-group .action-item.action-connection.not-exists {
  color: #d7d7d7;
}
.list-view .action-item.action-connection.not-updated, .list-view-group .action-item.action-connection.not-updated {
  color: #0288d1;
}
.list-view .action-clear-list, .list-view-group .action-clear-list {
  color: #dc3545;
}
.list-view .action-clear-list a, .list-view-group .action-clear-list a {
  cursor: pointer;
}
.list-view, .list-view-group {
  /* .action-ellipsis {
  	visibility: hidden;
  } */
}

.tracks-list-row {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.tracks-list-row .pull-right {
  margin-left: auto;
  opacity: 0.1;
  margin-right: 6px;
}
.tracks-list-row .pull-right:focus, .tracks-list-row .pull-right:hover {
  opacity: 1;
}

.tracks-list-row-head {
  border: none !important;
}
.tracks-list-row-head .trip-duration {
  min-width: 65px;
}
.tracks-list-row-head .trip-entity {
  font-weight: bold;
  border: none !important;
  text-indent: 5px;
  display: inline-block;
}
.tracks-list-row-head .trip-distance {
  min-width: 105px;
}

.tracks-list-row-wrap {
  position: relative;
}

.tracks-list-view {
  margin: 0;
  padding: 0;
  list-style: none;
}

.trip-entity {
  font-weight: normal;
  margin-right: 5px;
}

.trip-time,
.trip-distance {
  padding-right: 5px;
  min-width: 60px;
  display: inline-block;
}

.trip-time {
  min-width: 65px;
}

.list-view-group .list-row {
  box-shadow: none;
}

.group-view .list-view-group .list-row {
  padding-left: 5px;
}

.action-item svg {
  display: block;
}

.checkbox.full {
  display: block;
  width: auto;
}
.checkbox.full .unit-name {
  display: block;
  min-width: inherit !important;
  max-width: none !important;
}

.unit-details-box {
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid #B2B5C4;
}
.unit-details-box .time-address-row {
  margin-top: 0;
  line-height: 1.7;
}
.unit-details-box .statistics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  margin-bottom: 10px;
}
.unit-details-box .statistics-table td {
  text-align: center;
  border: 1px solid #B2B5C4;
  vertical-align: middle;
  padding: 10px;
}
.unit-details-box .caption-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.unit-details-box .caption-table td {
  border: 1px solid #B2B5C4;
  vertical-align: middle;
  padding: 5px 10px;
}
.unit-details-box .caption-table th {
  border: 1px solid #B2B5C4;
  background: #fff;
  font-weight: normal;
  padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Devices/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAGA;EACC,qBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFD;;AAKA;;;;EAAA;AAKA;EACC,aAAA;EACA,wBAAA;EACA,yBAAA;AAFD;;AAIC;EACA,cAAA;EAEA,WAAA;EACA,oBAAA;EAEA,mBAAA;EACA,eAAA;AAHD;;AAMC;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAHD;;AAKA;EACC,qBAAA;EACA,eAAA;EACA,mBAAA;AAFD;;AAIA;EACC,SAAA;AADD;;AAGA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eC6Bc;AD7Bf;AACC;EACC,mBAAA;AACF;AACC;EACC,cAAA;EACA,YAAA;AACF;AACE;EACC,iBAAA;AACH;AAIE;EACC,YAAA;AAFH;AAKC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,0BAAA;AAHF;AAKC;EACC,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AAHF;AAQE;EACC,sBAAA;AANH;AAQE;EACC,iBAAA;AANH;AAUC;EACE,cAAA;AARH;AAWE;EACC,aAAA;AATH;AAaC;EACC,WAAA;AAXF;AAYE;EACC,aAAA;EACA,mBAAA;AAVH;AAYE;EACC,cAAA;AAVH;AAYE;EACC,cAAA;EACA,sBAAA;AAVH;AAYE;EAEC,aAAA;AAXH;AAaE;EACC,cCzEU;AD8Db;AAaE;EAEC,cC1EW;AD8Dd;AAcE;EACC,cC/EQ;ADmEX;AAcE;EACC,cC9ES;ADkEZ;AAcE;EACC,cCnFW;ADuEd;AAiBE;EACC,gBAAA;AAfH;AAkBC;EAEC,cChGS;AD+EX;AAmBC;EACC,cC/FU;AD8EZ;AAmBC;EACC,cAAA;AAjBF;AAoBC;EACC,cC1GS;ADwFX;AAmBE;EACC,eAAA;AAjBH;AAlGA;EAwHC;;KAAA;AAjBD;;AAqBA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAlBD;AAmBC;EACC,iBAAA;EACA,YAAA;EACA,iBAAA;AAjBF;AAkBE;EAEC,UAAA;AAjBH;;AAqBA;EACC,uBAAA;AAlBD;AAmBC;EACC,eAAA;AAjBF;AAmBC;EACC,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;AAjBF;AAmBC;EACC,gBAAA;AAjBF;;AAoBA;EACC,kBAAA;AAjBD;;AAmBA;EACC,SAAA;EACA,UAAA;EACA,gBAAA;AAhBD;;AAkBA;EACC,mBAAA;EACA,iBAAA;AAfD;;AAiBA;;EAEC,kBAAA;EACA,eAAA;EACA,qBAAA;AAdD;;AAgBA;EACC,eAAA;AAbD;;AAiBC;EACC,gBAAA;AAdF;;AAmBC;EACC,iBAAA;AAhBF;;AAqBA;EAAmB,cAAA;AAjBnB;;AAoBA;EACC,cAAA;EACA,WAAA;AAjBD;AAkBC;EACC,cAAA;EACA,6BAAA;EACA,0BAAA;AAhBF;;AAoBA;EACC,gBAAA;EACA,aAAA;EACA,gCAAA;AAjBD;AAkBC;EACC,aAAA;EACA,gBAAA;AAhBF;AAkBC;EACC,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAhBF;AAiBE;EACC,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;AAfH;AAkBC;EACC,WAAA;EACA,yBAAA;EACA,mBAAA;AAhBF;AAiBE;EACC,yBAAA;EACA,sBAAA;EACA,iBAAA;AAfH;AAiBE;EACC,yBAAA;EACA,gBCjNiB;EDkNjB,mBAAA;EACA,iBAAA;AAfH","sourcesContent":["@import \"../../assets/variables\";\n\n// List Row\n.v-divider {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tborder-left: 1px solid darken($sidebarRowBg, 8%);\n\tmargin-left: 8px;\n\tmargin-right: 8px;\n\theight: 21px;\n}\n\n/* .individual-view {\n\theight: calc(100vh - #{$headerHeight} - #{$footerHeight} - 80px);\n\t//margin-right: -17px;\n}\n */\n.units-collapse{\n\tdisplay: flex;\n\tpadding: 5px 2px 0px 2px ;\n\tbackground-color: #f1f6f9;\n}\n .units-menu{\n\tmin-width: 27%;\n\t// max-width: 33%;\n\tmargin: 2px;\n\tdisplay: inline-flex;\n\t// justify-content: space-between;\n\talign-items: center;\n\tcursor: pointer;\n\t// background-color: #F1F6F9;\n }\n .units-menu-itemName{\n\tfont-size: 11px;\n\tfont-weight: bold;\n\tmargin-left: 2px;\n\tcursor: pointer;\n }\na.list-row,a.list-row * { \n\ttext-decoration: none;\n\tcursor: pointer;\n\talign-items: center;\n}\n.list-row.sticky {\n\tmargin: 0;\n}\n.list-view {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n\tfont-size: $baseFontSize;\n\t&.with-padding-right .list-row {\n\t\tpadding-right: 10px;\n\t}\n\t.list-row {\n\t\tdisplay: block;\n\t\tpadding: 5px;\t\t\t\n\t\t//border-bottom: 1px solid darken($sidebarRowBg, 8%);\n\t\t.pull-right {\n\t\t\ttext-align: right;\n\t\t}\n\n\t}\n\t.disabled-icons:not(.disabled-row) {\n\t\t.action-item {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n\t.list-footer-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 16px;\n\t\tdisplay: flex;\n\t\tpadding: 6px 10px;\n\t\tborder-radius: 0 0 6px 6px;\n\t}\n\t.trip-date-row {\n\t\tpadding-top: 4px;\n\t\tpadding-bottom: 4px;\n\t\tmargin-top: 5px;\n\t\tdisplay: flex;\n\t\tfont-weight: 600;\n\t\tfont-style: italic;\n\t\tline-height: 26px;\n\t\talign-items: center;\n\t\tborder-radius: 6px 6px 0 0;\n\n\t\t//span {\n\t\t\t//font-weight: 300;\n\t\t//}\n\t\t.material-icons {\n\t\t\tvertical-align: middle;\n\t\t}\n\t\t.pull-right {\n\t\t\tmargin-left: auto;\n\t\t}\n\t}\n\t\n\ta {\n\t \tcolor: inherit;\n\t}\n\t.not-updated {\n\t\t.action-running {\n\t\t\topacity: 0.25;\n\t\t}\n\n\t}\n\t.action-item {\n\t\tfloat: left;\n\t\t.tracks-view & {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t\ta {\n\t\t\tdisplay: block;\n\t\t}\n\t\t.material-icons, i {\n\t\t\tcolor: inherit;\n\t\t\tvertical-align: middle;\n\t\t}\n\t\t&.unknownunknown,\n\t\t&.unknownonline {\n\t\t\topacity: 0.25;\n\t\t}\n\t\t&.online {\n\t\t\tcolor: $greenColor;\n\t\t}\n\t\t&.unknownunknown,\n\t\t&.unknown {\n\t\t\tcolor: $yellowColor;\n\t\t}\t\t\n\t\t&.stop {\n\t\t\tcolor: $redColor;\n\t\t}\n\t\t&.offline {\n\t\t\tcolor: $lightGrey;\n\t\t}\n\t\t&.away {\n\t\t\tcolor: $yellowColor;\n\t\t}\n\t\t.circle {\n\t\t\t//margin-top: -0.2em;\n\t\t}\n\t\t.sub-menu {\n\t\t\tmin-width: 200px;\n\t\t}\n\t}\n\t.action-item.action-connection.offline {\n\t\t//color: #0288d1;\n\t\tcolor: $redColor;\n\t}\n\t.action-item.action-connection.not-exists {\n\t\tcolor: $lightGrey;\n\t}\n\t.action-item.action-connection.not-updated {\n\t\tcolor: #0288d1;\n\t}\n\n\t.action-clear-list {\n\t\tcolor: $redColor;\n\t\ta {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t\n\t/* .action-ellipsis {\n\t\tvisibility: hidden;\n\t} */\n}\n.tracks-list-row {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 8px 0;\n\t.pull-right {\n\t\tmargin-left: auto;\n\t\topacity: 0.1;\n\t\tmargin-right: 6px;\n\t\t&:focus,\n\t\t&:hover {\n\t\t\topacity: 1;\n\t\t}\n\t}\n}\n.tracks-list-row-head {\n\tborder: none !important;\n\t.trip-duration {\n\t\tmin-width: 65px;\n\t}\n\t.trip-entity {\n\t\tfont-weight: bold;\n\t\tborder: none !important;\n\t\ttext-indent: 5px;\n\t\tdisplay: inline-block;\n\t}\n\t.trip-distance {\n\t\tmin-width: 105px;\n\t}\n}\n.tracks-list-row-wrap {\n\tposition: relative;\n}\n.tracks-list-view {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n.trip-entity {\n\tfont-weight: normal;\n\tmargin-right: 5px;\n}\n.trip-time,\n.trip-distance {\n\tpadding-right: 5px;\n\tmin-width: 60px;\n\tdisplay: inline-block;\n}\n.trip-time {\n\tmin-width: 65px;\n}\n.list-view-group {\n\t@extend .list-view;\n\t.list-row {\n\t\tbox-shadow: none;\n\t}\n}\n\n.group-view {\n\t.list-view-group .list-row {\n\t\tpadding-left: 5px;\n\t\t\n\t}\n}\n\n.action-item svg { display: block;}\n\n\n.checkbox.full {\n\tdisplay: block;\n\twidth: auto;\n\t.unit-name {\n\t\tdisplay: block;\n\t\tmin-width: inherit !important;\n\t\tmax-width: none !important;\n\t}\n}\n\n.unit-details-box {\n\tbackground: #fff;\n\tpadding: 10px;\n\tborder-bottom: 1px solid $borderColor;\n\t.time-address-row {\n\t\tmargin-top: 0;\n\t\tline-height: 1.7;\n\t}\n\t.statistics-table {\n\t\twidth: 100%;\n\t\tborder-collapse:  collapse;\n\t\tfont-size: $baseFontSize + 2;\n\t\tmargin-bottom: 10px;\n\t\ttd {\n\t\t\ttext-align: center;\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tvertical-align: middle;\n\t\t\tpadding: 10px;\n\t\t}\n\t}\n\t.caption-table {\n\t\twidth: 100%;\n\t\tborder-collapse:  collapse;\n\t\tmargin-bottom: 10px;\n\t\ttd {\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tvertical-align: middle;\n\t\t\tpadding: 5px 10px;\n\t\t}\n\t\tth {\n\t\t\tborder: 1px solid $borderColor;\n\t\t\tbackground: $sidebarBackground;\n\t\t\tfont-weight: normal;\n\t\t\tpadding: 5px 10px;\n\t\t}\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
